import { mapKeys, mapValues, isObject } from 'lodash';

export function convertKeys<T extends object>(
  obj: T,
  caseConverter: (key: string) => string
): T {
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeys(item, caseConverter)) as unknown as T;
  } else if (isObject(obj) && obj !== null) {
    const transformed = mapKeys(obj, (_, key) => caseConverter(key));

    return mapValues(transformed, value => isObject(value)
        ? convertKeys(value, caseConverter)
        : value
      ) as T;
    }

    return obj;
}